export default "__VITE_ASSET__Djfi4s3V__"